export default (block) => {
  block.logoSrc = block.brandLogo.filename
  block.url = block.linkPath.cached_url
  return block
}
